/* eslint-disable no-unused-vars */
/* eslint-disable no-control-regex */
/* eslint-disable no-undef */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useMemo } from 'react';
import { DateTime } from 'luxon';
import PlaceHolder from '../utils/PlaceHolder.js';
import { v4 as uuid } from 'uuid';
import { GetFileType, NewlineText, getBrand, getImage, openInBrowser, readAsText, readBase64, resizeImage } from '../utils/Helpers.js';
import { BsAsterisk, BsBook, BsCalculator, BsCalendar3, BsCalendarEvent, BsChatDots, BsFileEarmarkPerson, BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill, BsFillFileEarmarkPdfFill, BsFillHouseHeartFill, BsFillTrashFill, BsFolder2Open, BsPatchQuestionFill } from 'react-icons/bs/index.js';
import { MdLibraryAdd } from 'react-icons/md/index.js';
import { ImBackward2, ImForward2, ImPlay } from 'react-icons/im/index.js';
import { BiEdit, BiHelpCircle, BiMenu, BiSearchAlt } from 'react-icons/bi/index.js';
import { FiSettings } from 'react-icons/fi/index.js';
import { IoArrowRedoSharp, IoArrowUndoSharp, IoGameController } from 'react-icons/io5/index.js';
import { FaBirthdayCake, FaPhotoVideo, FaShareSquare } from 'react-icons/fa/index.js';
import { IoMdClose } from 'react-icons/io/index.js';
import { AiOutlineDashboard, AiOutlineFileProtect, AiOutlineFileUnknown } from 'react-icons/ai/index.js';
import { GiSave, GiTestTubes } from 'react-icons/gi/index.js';
import { HiOutlineLogout } from 'react-icons/hi/index.js';
import Redirect from '../utils/Redirect.js';
import UserContext from '../utils/UserContext.js';
import Session from '../utils/Session.js';
import './Loading.css';


const GLOBAL_LINKS = Session.object('LINKS') || {};


export const TopMenu = (props) => {
    return <div id="TopMenu" className="text-start">
        {props.children}
        {props.accounts && <Link to="/accounts"><BsCalculator /> Accounts</Link>}
        {props.settings && <Link to="/schoolsettings"><SettingsIcon /> Settings</Link>}
        {props.menu && <Link to="/school"><MenuIcon /> Menu</Link>}
    </div>;
};

// eslint-disable-next-line no-unused-vars
export const AccountsMenu = ({ tab = 0 }) => {
    return <TopMenu accounts={true} menu={true} ></TopMenu>;
};

// eslint-disable-next-line no-unused-vars
export const SettingsMenu = ({ tab = 0 }) => {
    return <TopMenu settings={true} menu={true} ></TopMenu>;
};

// eslint-disable-next-line no-unused-vars
export const ReportMenu = ({ tab = 0 }) => {
    return <TopMenu settings={false} menu={true} >
        <Link to="/school/reports" className={'btn w3-theme2-d2 border-start w3-hover-opacity me-1'}><BackIcon /> Reports</Link>
    </TopMenu>;
};


export const CampusMenu = ({ tab = 0 }) => {
    return <TopMenu settings={true} menu={true} >
        {tab != 2 && <Link to="/schoolsettings/createcampus" className={'btn w3-theme2-d2 border-start w3-hover-opacity me-1'}><AddIcon /> New Campus</Link>}
        {tab != 1 && <Link to="/schoolsettings/campus" className={'btn w3-theme2-d2 border-start w3-hover-opacity me-1'}><BsFillHouseHeartFill /> Campuses</Link>}
    </TopMenu>;
};


export const AdminSmartCardMenu = ({ tab = 0 }) => {
    return <TopMenu menu={true} >
        {tab != 1 && <Link to="/school/editattendance" className={'btn w3-theme2-d2 border-end w3-hover-opacity'}><EditIcon /> Modify Attendance</Link>}
        {tab != 2 && <Link to="/school/assigncards" className={'btn w3-theme2-d2 w3-hover-opacity'}><CheckOutIcon /> Assign Cards</Link>}
        {tab != 3 && <Link to="/school/clearsmartcards" className={'btn w3-theme2-d2 border-start w3-hover-opacity'}><TrashIcon /> Delete Cards</Link>}
    </TopMenu>;
};

export const ReportCardMenu = ({ tab = 0 }) => {
    return <TopMenu menu={true} >
        {tab != 1 && <Link to="/school/createreportcards" className={'btn w3-theme2-d2 me-1 w3-hover-opacity'}>Create</Link>}
        {tab != 2 && <Link to="/school/uploadreportcards" className={'btn w3-theme2-d2 w3-hover-opacity'}>Upload</Link>}
        {tab != 3 && <Link to="/school/resulttemplate" className={'btn w3-theme2-d2 ms-1 w3-hover-opacity'}>Templates</Link>}
    </TopMenu>;
};

export const CBTMenu = ({ tab = 0 }) => {
    return <TopMenu menu={false} >
        {tab != 1 && <Link to="/school/newquestionbank" className={'btn w3-theme2-d2 border-end w3-hover-opacity'}><BsPatchQuestionFill className="d-none d-md-inline" /> Create Questions</Link>}
        {tab != 2 && <Link to="/school/managequestionbank" className={'btn w3-theme2-d2 w3-hover-opacity'}><GiTestTubes className="d-none d-md-inline" /> Create Test</Link>}
        {tab != 3 && <Link to="/school/assignedquestions" className={'btn w3-theme2-d2 border-start w3-hover-opacity'}><AiOutlineFileProtect className="d-none d-md-inline" /> Results</Link>}
        <Link to="/school"><MenuIcon /> Menu</Link>
    </TopMenu>;
};

export const LearningAidsMenu = ({ tab = 0 }) => {
    return <TopMenu menu={true} >
        {tab != 1 && <Link to="/school/syllabuxvideos" ><FaPhotoVideo className="d-none d-md-inline" /> Videos</Link>}
        {tab != 2 && <Link to="/school/syllabuxgames" ><IoGameController className="d-none d-md-inline" /> Games</Link>}
        {tab != 3 && <Link to="/school/learningaidsassigned" ><AiOutlineFileProtect className="d-none d-md-inline" /> Results</Link>}
    </TopMenu>;
};

export const EventsMenu = ({ tab = 0 }) => {
    return <TopMenu menu={true} >
        {tab != 1 && <Link to="/school/birthdays" ><FaBirthdayCake /> Birthdays</Link>}
        {tab != 2 && <Link to="/school/calendar" ><BsCalendar3 /> Academic Calendar</Link>}
    </TopMenu>;
};

export const SearchIcon = (props) => {
    return <BiSearchAlt  {...props} />;
};

export const PersonIcon = (props) => {
    return <BsFileEarmarkPerson  {...props} />;
};

export const PDFIcon = (props) => {
    return <BsFillFileEarmarkPdfFill  {...props} />;
};

export const RightArrowIcon = (props) => {
    return <BsFillArrowRightCircleFill  {...props} />;
};
export const LeftArrowIcon = (props) => {
    return <BsFillArrowLeftCircleFill  {...props} />;
};
export const PlayIcon = (props) => {
    return <ImPlay  {...props} />;
};

export const CloseIcon = (props) => {
    return <IoMdClose  {...props} />;
};
export const ChatIcon = (props) => {
    return <BsChatDots {...props} />;
};

export const ShareIcon = (props) => {
    return <FaShareSquare {...props} />;
};

export const CheckInIcon = (props) => {
    return <IoArrowRedoSharp {...props} />;
};
export const CheckOutIcon = (props) => {
    return <IoArrowUndoSharp {...props} />;
};

export const SettingsIcon = (props) => {
    return <FiSettings {...props} />;
};

export const OpenIcon = (props) => {
    return <BsFolder2Open {...props} />;
};

export const EditIcon = (props) => {
    return <BiEdit {...props} />;
};

export const AsteriskIcon = ({ className = '' }) => {
    if (!className || className.length == 0) {
        return <BsAsterisk className='w3-text-red' style={{ fontSize: '10px', verticalAlign: 'top' }} />;
    }
    return <BsAsterisk className={className} />;
};

export const MenuIcon = (props) => {
    return <BiMenu {...props} />;
};

export const BackIcon = ({ className = 'animated-pointer-side' }) => {
    return <ImBackward2 className={className} />;
};

export const NextIcon = ({ className = 'animated-pointer-side' }) => {
    return <ImForward2 className={className} />;
};
export const AddIcon = (props) => {
    return <MdLibraryAdd {...props} />;
};

export const TrashIcon = (props) => {
    return <BsFillTrashFill {...props} />;
};

export const SaveIcon = (props) => {
    return <GiSave {...props} />;
};

export const BookIcon = (props) => {
    return <BsBook {...props} />;
};

export const NavBar = (props) => {
    const brand = getBrand();
    const [theme, setTheme] = useState(Session.value('theme') || 'light')
    const myContext = React.useContext(UserContext);

    let logo = <img src={GLOBAL_LINKS.school + 'images/100x100.png'} className='mh-35p mb-2 me-2' alt='Syllabux' />;
    let schoolName = 'SYLLABUX';
    let slogan = 'Smart School Solution';

    if (myContext.school?.plan == 'PLATINUM') {
        schoolName = myContext.school?.name;
        slogan = 'Powered by Syllabux';
        logo = <img src={GLOBAL_LINKS.cdn + myContext.school?.logo} className='mh-35p mb-2 me-2' alt={myContext.school.name} />;
    }

    useEffect(() => {
        const closeOffCanvas = document.getElementById('demo');
        const myOffCanvas = new bootstrap.Offcanvas(closeOffCanvas);
        closeOffCanvas.addEventListener('click', () => {
            myOffCanvas.hide();
        });
        if (theme == 'light') {
            document.body.classList.remove("darkmode--activated");
        } else if (theme == 'dark') {
            document.body.classList.add("darkmode--activated");
        } else {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                // Dark mode is preferred by the user
                document.body.classList.add("darkmode--activated");
            } else {
                // Light mode is preferred by the user or the browser doesn't support detecting color scheme preference
                document.body.classList.remove("darkmode--activated");
            }
        }
    }, []);

    return (
        <>
            <div className="offcanvas offcanvas-end syllabux-white" id="demo">
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title w3-wide">{schoolName}</h3>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas"></button>
                </div>
                <div className="offcanvas-body">
                    <ul id="closeOffCanvas" className="list-group list-group">
                        {props.children}
                        <Link className="list-group-item list-group-item-action" to="/dashboard">Dashboard</Link>

                    </ul>
                    <div className="list-group mt-4">
                        <h4 className="list-group-item my-0">Help</h4>
                        <button onClick={() => openInBrowser('https://docs.google.com/forms/d/e/1FAIpQLSeooVrUTsP02e9DAkGm6XV4M-98fESOg5zhSdjgytoS7bp9Rg/viewform?usp=sf_link')} className="list-group-item list-group-item-action" >Report a problem/bug</button>
                        <button onClick={() => openInBrowser('https://docs.google.com/forms/d/e/1FAIpQLSduWaE0-wyi2CllX36VF-NSHSfuRN5OBKHGgJyk__dvv5gAwQ/viewform?usp=sf_link')} className="list-group-item list-group-item-action" >Request a Feature</button>
                        <button onClick={() => openInBrowser('https://syllabux.cyou/faq-2.html')} className="list-group-item list-group-item-action">Teachers&apos; Tutorial</button>

                        <button onClick={() => openInBrowser('https://syllabux.cyou/faq-3.html')} className="list-group-item list-group-item-action">Admin Tutorial</button>

                        <button onClick={() => openInBrowser('https://syllabux.cyou/faq-4.html')} className="list-group-item list-group-item-action">Account Tutorial</button>

                        <button onClick={() => openInBrowser('https://www.youtube.com/@syllabux/videos')} className="list-group-item list-group-item-action">Video Tutorials</button>

                    </div>
                    <select className="form-control my-4 py-2" value={theme} onChange={(e) => {
                        setTheme(e.target.value);
                        Session.setValue('theme', e.target.value);
                        if (e.target.value == 'light') {
                            document.body.classList.remove("darkmode--activated");
                        } else if (e.target.value == 'dark') {
                            document.body.classList.add("darkmode--activated");
                        } else {
                            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                                // Dark mode is preferred by the user
                                document.body.classList.add("darkmode--activated");
                            } else {
                                // Light mode is preferred by the user or the browser doesn't support detecting color scheme preference
                                document.body.classList.remove("darkmode--activated");
                            }
                        }
                    }}>
                        <option value="light">Theme - Light</option>
                        <option value="dark">Theme - Dark</option>
                        <option value="auto">Theme - Auto</option>
                    </select>
                    <button onClick={() => {
                        if (confirm('Log out of your account?')) Redirect('/logout');
                    }} className="btn btn-danger w-100 mt-5" type="button">Logout</button>
                </div>
            </div>
            <div className="navbar d-block w-100 w3-card-2">
                <div className="container my-0 py-0">
                    <div className='d-flex w-100'>
                        <Link to="/dashboard" className='d-flex align-items-center text-decoration-none'>
                            {logo}
                            <div>
                                <h5 className='fw-normal w3-wide mb-0 pb-0'>{schoolName}</h5>
                                <p className='small w3-opacity mt-0 pt-0'>{slogan}</p>

                            </div>
                        </Link>
                        <div className='ms-auto'>
                            <button data-bs-toggle="offcanvas" data-bs-target="#demo" className='w3-btn btn w3-opacity w3-hover-text-black pt-1 fs-1'><MenuIcon /></button>
                        </div>
                    </div>
                </div>
            </div>
            <div className=''>&nbsp;</div>
        </>

    );
};


export const PreLoginLogo = (props) => {
    const brand = getBrand();
    // eslint-disable-next-line no-undef
    const logo = brand?.schoolName?.length > 2 ? <h3 className="brand mb-0">{brand.schoolName}</h3> : <img src={GLOBAL_LINKS.school + 'images/syllabux4.svg'} className='w-70 mt-1' alt='School Logo' />;
    const slogan = brand?.slogan?.length > 2 ? brand.slogan : 'Experience the future of education';
    return <div>
        <div className='w3-center pt-5'>
            {logo}
            <div className='w3-text-theme2'>{slogan}</div>
        </div>

        <div className='w3-center my-3'>
            <div className="w3-bar w3-round-large">
                {props.children}
            </div>
        </div>

    </div>;
};




export const SimpleLogo = () => {
    const nav = useNavigate();
    const brand = getBrand();
    // eslint-disable-next-line no-undef
    const logo = brand?.schoolName?.length > 2 ? <h3 className="brand mb-0">{brand.schoolName}</h3> : <img src={GLOBAL_LINKS.school + 'images/syllabux4.svg'} style={{ maxHeight: '65px' }} className='mw-75 mt-1' alt='School Logo' />;
    const slogan = brand?.slogan?.length > 2 ? brand.slogan : 'Unlock Your School\'s Future with A.I.';
    return <div className='text-start'>
        <div onClick={() => nav('/dashboard')} className='pointer'>
            {logo}
            <div className=''>{slogan}</div>
        </div>
    </div>;
};


export const PageTitle = ({ _title }) => {
    return (
        <h3 className="w3-container w3-xxlarge">{_title}</h3>
    );
};

export const SectionTitle = ({ _title }) => {
    return (
        <h3 className="w3-container w3-xlarge">{_title}</h3>
    );
};

export const Section = (props) => {
    return <div className='mx-2 my-3 border py-2 w3-round-large w3-theme2-l4'>
        <h4 className='w3-container mt-2'>{props._title}</h4>
        {props.children}
    </div>;
};

export const ListItem1 = (props) => {
    const click = () => { };
    const background = props._background || 'w3-theme2-d2';
    return <div className={`btn w3-bar my-2 text-start w3-card-2 ${background} p-2 w3-round-large`} onClick={props._onClick || click}>
        {props.children}
    </div>;
};



export const Footer = (props) => {
    const pagesExcludedFromAds = [
        // 'https://school.mysyllabux.com/school',
        'https://school.mysyllabux.com/dashboard',
        'https://school.mysyllabux.com/dashboard/select',
        'https://school.mysyllabux.com/dashboard/join',
        'https://school.mysyllabux.com/dashboard/create',
    ]

    const myContext = React.useContext(UserContext);
    let isFree = myContext.school?.plan == 'FREE' ? true : false;

    useEffect(() => {
        if (isFree) {
            try {
                // eslint-disable-next-line no-undef
                // disable 
           //     Website2APK.showInterstitialAd();
            } catch (e) {
                /** */
            }
        }
        // const currentPage = window.location.href;
        // if (!isFree || pagesExcludedFromAds.includes(currentPage)) {
        //     isFree = false;
        //     return;
        // }
        // try {
        //     (window.adsbygoogle = window.adsbygoogle || []).push({});
        // } catch (e) {
        //     /** */
        // }

    }, []);
    return <>
        <div className='py-4'>&nbsp;</div>

        <div className='w3-center w3-card-2 footer'>
            <div className='container'>{props.children}</div>
        </div>
    </>;
};

export const SubHeading = ({ _title }) => {
    return (
        <h3 className='w3-xlarge w3-center p-2 w3-card-2 mx-3 syllabux-light' >{_title}</h3>
    );
};

export const BlockButton = ({ _name, _method = '', _parentClass = 'w3-container', _class = 'btn btn-lg w3-theme2-d1 w3-hover-opacity w3-block mt-2 mb-2', _type = 'button' }) => {
    const ignore = () => { };
    return (
        <div className={_parentClass}>
            <button type={_type} onClick={_method || ignore} className={_class}>{_name}</button>
        </div>
    );
};
export const Button = ({ _name, _method = '', _class = 'btn w3-theme2-d1 w3-hover-opacity mt-2 mb-2 mx-1', _type = 'button' }) => {
    const ignore = () => { };
    return (
        <button type={_type} onClick={_method || ignore} className={_class}>{_name}</button>
    );
};



export const HrefButon = ({ _name, _url }) => {
    return (
        <Link to={_url} className="btng w3-highway-blue w3-hover-red mt-4 mb-4">{_name}</Link>
    );
};

export const TextInput = ({ _label, _type = 'text', _parentClass = 'w3-container', _value = '', _name = null, _onChange = null }) => {
    return (
        <div className={_parentClass}>
            <div className="form-floating mb-2 mt-2" >
                {_onChange &&
                    <input
                        type={_type}
                        value={_value}
                        className="form-control"
                        // placeholder={_label}
                        onChange={_onChange}
                        name={_name}
                    />
                }
                <label>{_label}</label>
            </div>
        </div>
    );
};

export const FileInput = ({ _label, _name = '', _parentClass = 'w3-container', _id = '', _onChange = null }) => {
    return (
        <div className={_parentClass}>
            <div className="form-floating mb-2 mt-2" >
                <input
                    type="file"
                    className="form-control"
                    placeholder={_label}
                    onChange={_onChange}
                    name={_name}
                    id={_id}
                />

                <label>{_label}</label>
            </div>
        </div>
    );
};

export const FileInputText = ({ _label, _id = null, _parentClass = 'w3-container', _onChange = null, }) => {
    const [text, setText] = useState('');
    const id = _id || uuid();
    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file 

    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file 
    const handleChange = async (event) => {
        const text = await readAsText(event.target.files[0]);
        _onChange(text);
        const formatter = Intl.NumberFormat('en', { notation: 'compact' });
        let n = formatter.format(text.length);
        setText(n);
    };



    return (
        <div className={_parentClass}>
            <input
                type="file"
                id={id}
                onChange={handleChange}
                accept="text/*"
                style={{ display: 'none' }}
            />
            {
                text &&
                <div className='w3-container mt-3 pb-3 w3-display-container  w3-animate-zoom'>

                    <h3 className='w3-center text-center my-0'>{text}b File</h3>
                    <div onClick={() => {
                        setText('');
                        document.getElementById(id).value = '';
                        _onChange('');
                    }} className="w3-display-topleft btn w3-sand p-0">
                        <div className='text-shadow w3-sand w3-text-red w3-xlarge'>
                            <CloseIcon />
                        </div>
                    </div>
                </div>
            }
            <button onClick={() => document.getElementById(id).click()} type='button' className='btn btn-lg w3-theme2-d1 w3-hover-opacity w3-block mt-2 mb-2'>{_label}</button>
        </div>
    );
};

export const FileInputBase64 = ({ _label, _id = null, _parentClass = 'w3-container', _onChange = null, }) => {
    const [text, setText] = useState('');
    const id = _id || uuid();
    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file 

    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file 
    const handleChange = async (event) => {
        const text = await readBase64(event.target.files[0]);

        _onChange(text);
        const formatter = Intl.NumberFormat('en', { notation: 'compact' });
        let n = formatter.format(text.length);
        setText(n);
    };



    return (
        <div className={_parentClass}>
            <input
                type="file"
                id={id}
                onChange={handleChange}
                accept="image/*,application/pdf,video/*,audio/*"
                style={{ display: 'none' }}
            />
            {
                text &&
                <div className='w3-container mt-3 pb-3 w3-display-container  w3-animate-zoom'>

                    <h3 className='w3-center text-center my-0'>{text}b File</h3>
                    <div onClick={() => {
                        setText('');
                        document.getElementById(id).value = '';
                        _onChange('');
                    }} className="w3-display-topleft btn w3-sand p-0">
                        <div className='text-shadow w3-sand w3-text-red w3-xlarge'>
                            <CloseIcon />
                        </div>
                    </div>
                </div>
            }
            <button onClick={() => document.getElementById(id).click()} type='button' className='btn btn-lg w3-orange w3-hover-opacity w3-block mt-2 mb-2'>{_label}</button>
        </div>
    );
};


export const ImageInput = ({ _label, _defaultImage = '', _name = '', _id = '', _onChange = null, _clear }) => {
    const [image, setImage] = useState(_defaultImage);
    const id = _id || uuid();
    return (
        <div className="w3-container">
            {
                image &&
                <div className='w3-container mt-3 w3-display-container w3-animate-zoom'>
                    <img src={image} className="w3-container img-thumbnail w-100" />
                    <div onClick={() => {
                        setImage(_defaultImage);
                        document.getElementById(id).value = '';
                        _clear && _clear();
                    }} className="w3-padding w3-display-topleft btn">
                        <div className='text-shadow w-50 ps-3 w3-text-red w3-xlarge'>
                            <i className='bi bi-x-square'></i>
                        </div>
                    </div>
                </div>
            }
            <div className="form-floating mb-2 mt-2" >
                <input
                    type="file"
                    className="form-control"
                    placeholder={_label}
                    accept="image/*"
                    onChange={event => { _onChange(event); setImage(URL.createObjectURL(event.target.files[0])); }}
                    name={_name}
                    id={id}
                />

                <label>{_label}</label>
            </div>
        </div>
    );
};

export const ImageInputBase64 = ({ _replaceClass = '', _parentClass = 'w3-container', _label, _defaultImage = '', _id = null, _onChange = null, _display = 'img-thumbnail w-75 mw-75 mx-auto' }) => {
    const [image, setImage] = useState(_defaultImage);
    const id = _id || uuid();
    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file 
    const handleChange = async (event) => {
        const b64 = await resizeImage(event.target.files[0]);
        _onChange(b64);
        setImage(b64);
    };


    return (
        <div className={_parentClass}>
            <div className={image && 'd-none'}>
                <a onClick={() => document.getElementById(id).click()} className={_replaceClass.length > 0 ? _replaceClass + ' text-decoration-none' : 'btn w3-theme2-d1 w3-hover-opacity w3-block mt-2 mb-2'}>{_label}</a>
            </div>
            <input
                type="file"
                id={id}
                onChange={handleChange}
                accept="image/*"
                style={{ display: 'none' }}
            />
            {
                image &&
                <div className='mt-3 w3-display-container  w3-animate-zoom'>
                    <div className='w3-center text-center'><img src={image} className={_display} style={{ maxWidth: '100%' }} /></div>
                    <span onClick={() => {
                        setImage('');
                        document.getElementById(id).value = '';
                        _onChange('');
                    }} className="btn btn-sm w3-display-topleft w3-red w3-large p-0">
                        <CloseIcon className="w3-text-white m-0" />
                    </span>
                </div>
            }
        </div>
    );
};



export const CheckInput = ({ _label, _parentClass = 'w3-container', _value = '', _name = '', _onChange = null }) => {
    return (
        <div className={_parentClass + ' my-2'}>
            <label className="w-100" >
                <div className="w3-border w3-round-large p-2 syllabux-light">
                    <input className="w3-check" type="checkbox" checked={_value || false} name={_name} onChange={_onChange} />
                    &nbsp;{_label}
                </div>
            </label>
        </div>
    );
};

export const TextArea = ({ _label, _parentClass = 'w3-container', _value = '', _class = 'form-control textarea', _name = null, _onChange = null }) => {
    return (
        <div className={_parentClass}>
            <div className="form-floating mb-2 mt-2" >
                <textarea value={_value} name={_name} className={_class} onChange={_onChange} placeholder={_label} />
                <label>{_label}</label>
            </div>
        </div>
    );
};

export const SelectInput = ({ _label, _parentClass = 'w3-container', _value = '', _options = [], _name = null, _onChange = null, children = '' }) => {
    const optionz = children != '' ? children : _options?.map(el => <option key={el[0]} value={el[0]}>{el[1]}</option>);

    return (
        <div className={_parentClass}>
            <div className="form-floating mb-2 mt-2" >
                <select name={_name} value={_value} onChange={_onChange} className='form-control'>
                    {optionz}
                </select>

                <label>{_label}</label>
            </div>
        </div>
    );
};

export const SearchableSelectInput = ({ _label, _parentClass = 'w3-container', _value = '', _options = [], _name = null, _onChange = null, children = '', _placeholder = 'Type to search...' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredOptions, setFilteredOptions] = useState([]);
    
    // Get options from children or _options prop
    const allOptions = useMemo(() => {
        if (children && Array.isArray(children)) {
            try {
                // Flatten the children array in case it contains nested arrays
                const flatChildren = children.flat();
                
                const parsedOptions = flatChildren
                    .filter(child => child && child.props && child.props.value !== undefined)
                    .map(child => {
                        // Handle children that might be an array of text nodes
                        let label = child.props.children;
                        if (Array.isArray(label)) {
                            label = label.join('');
                        } else if (typeof label !== 'string') {
                            label = String(label || '');
                        }
                        return { 
                            value: child.props.value, 
                            label: label
                        };
                    });
                
                return parsedOptions;
            } catch (error) {
                console.warn('Error parsing children options:', error);
                return [];
            }
        }
        
        return _options?.map(el => ({ value: el[0], label: el[1] })) || [];
    }, [children, _options]);

    // Initialize filtered options
    useEffect(() => {
        setFilteredOptions(allOptions);
    }, [allOptions.length]); // Only when options change

    // Get display value for selected option
    const selectedOption = allOptions.find(option => option.value === _value);
    const displayValue = selectedOption 
        ? (typeof selectedOption.label === 'string' 
            ? selectedOption.label 
            : String(selectedOption.label || ''))
        : '';

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setIsOpen(true);
        
        // Filter options based on search term
        if (value.trim() === '') {
            setFilteredOptions(allOptions);
        } else {
            const filtered = allOptions.filter(option => {
                // Convert label to string safely
                const labelStr = typeof option.label === 'string' 
                    ? option.label 
                    : String(option.label || '');
                return labelStr.toLowerCase().includes(value.toLowerCase());
            });
            setFilteredOptions(filtered);
        }
    };

    const handleOptionClick = (option) => {
        if (_onChange) {
            const syntheticEvent = {
                target: {
                    name: _name,
                    value: option.value
                }
            };
            _onChange(syntheticEvent);
        }
        setSearchTerm('');
        setIsOpen(false);
    };

    const handleInputFocus = () => {
        setIsOpen(true);
        setSearchTerm('');
        // Show all options on focus (like a regular select)
        setFilteredOptions(allOptions);
    };

    const handleInputBlur = () => {
        // Delay closing to allow option clicks
        setTimeout(() => {
            setIsOpen(false);
            // Reset search term when closing
            setSearchTerm('');
        }, 200);
    };

    const handleInputClick = () => {
        setIsOpen(true);
        setSearchTerm('');
        // Show all options when clicking (like a regular select)
        setFilteredOptions(allOptions);
    };

    return (
        <div className={_parentClass}>
            <div className="form-floating mb-2 mt-2 position-relative">
                <input
                    type="text"
                    className="form-control"
                    value={isOpen ? searchTerm : displayValue}
                    onChange={handleInputChange}
                    onFocus={handleInputFocus}
                    onBlur={handleInputBlur}
                    onClick={handleInputClick}
                    placeholder={isOpen ? _placeholder : (displayValue || _placeholder)}
                    autoComplete="off"
                />
                <label>{_label}</label>
                
                {isOpen && (
                    <div className="position-absolute w-100 bg-white border border-top-0 rounded-bottom shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map(option => (
                                <div
                                    key={option.value}
                                    className="px-3 py-2 cursor-pointer hover-bg-light"
                                    onClick={() => handleOptionClick(option)}
                                    style={{ cursor: 'pointer' }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                >
                                    {option.label}
                                </div>
                            ))
                        ) : (
                            <div className="px-3 py-2 text-muted">No options found</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};




export const DateBar = ({ _title }) => {
    return (
        <h3 className='mt-4 mb-1 w3-text-theme2' ><BsCalendarEvent /> {_title}</h3>
    );
};


export const ChatBubble = ({ _message, _pupil = null, _button = null }) => {
    const _class = _message.isParent ? ' syllabux-white w-75 ms-0 w3-border border border-muted chatty2 mb-3 pt-3 pe-3 ps-3 me-4' : 'syllabux-light w-75 ms-auto chatty1 mb-3 pt-3 pe-3 ps-3 ms-4';
    const _namePos = _message.isParent ? 'd-flex justify-content-start' : 'd-flex justify-content-end';
    const dateObj = DateTime.fromSeconds(_message.created_at).toLocal();
    const _datex = dateObj.toFormat('EEE, MMM dd');
    const _relativeTime = dateObj.toRelativeCalendar();
    const _time = dateObj.toFormat('h:mma');

    return (
        <div className="mb-4">
            <div style={{ fontSize: '90%' }} className={_namePos + ' text-muted m-0 p-0 align-items-end'}>{_datex} {_time} {_button}</div>
            <div className={_class}>
                <div className='w3-center lgm-600p mx-auto'>
                    {(_message.fileType == 'IMAGE' || GetFileType(_message.file) == 'IMAGE') && <span onClick={() => openInBrowser(getImage(_message.file))} download={_message.file}><img loading='lazy' src={getImage(_message.file)} className="mw-100  lgm-600p mx-auto img-thumbnail mb-2" alt="Image" /></span>}
                    {_message.fileType === 'AUDIO' && <audio className='w-100 mb-2' src={getImage(_message.file)} preload="none" controls />}
                    {_message.fileType === 'VIDEO' && <video width="100%" src={getImage(_message.file)} className='w-100' controls="controls" preload="none" />}
                    {_message.fileType === 'DOCUMENT' && <span onClick={() => openInBrowser(getImage(_message.file))} className='btn btn-block w3-block w3-theme2-d4 w3-hover-theme1 mb-2' >Download Document</span>}
                </div>
                <NewlineText>{PlaceHolder(_message.message.replace(/[^\x00-\x7F]/g, ''), _pupil)}</NewlineText>
                <div className={_namePos}>
                    <div className='mt-3 mb-1 w3-medium'>--{_message.createdBy}</div>
                </div>

            </div>
        </div>
    );
};


export const ActivityBubble = ({ _message, _pupil = null }) => {
    const dateObj = _message.created_at ? DateTime.fromSeconds(_message.created_at).toLocal() : DateTime.now();
    const _datex = dateObj.toFormat('EEE, MMMM dd');
    const _relativeTime = dateObj.toRelativeCalendar();
    const _time = dateObj.toFormat('h:mma');
    let message;
    try {
        message = JSON.parse(_message.message);

        const out = message.map((el, index) => {
            if (el.icon?.length > 1) {
                return <div key={index}><img loading="lazy" src={
                    // eslint-disable-next-line no-undef
                    el.icon.includes(GLOBAL_LINKS.school) ? el.icon : GLOBAL_LINKS.school + el.icon
                } className="icon" alt="icon" /> {PlaceHolder(el.message.replace(/[^\x00-\x7F]/g, ''), _pupil)}</div>;
            } else {
                return <div key={index}>{PlaceHolder(el.message.replace(/[^\x00-\x7F]/g, ''), _pupil)}</div>;
            }
        });

        message = out;
    } catch (e) {
        message = PlaceHolder(_message.message, _pupil);
    }

    // if(_message.fileType?.length < 1 && message.length < 3) return null;

    return (
        <div className="flex-grow-1">
            <div className='text-start pb-1 w3-small'><BsCalendarEvent /> {_datex} {_time} ({_relativeTime})</div>
            <div className='syllabux-white w3-hover-grey w3-border w3-border-white w3-round-large w3-card-2 mb-1 pt-1 pe-3 ps-3'>
                {_message.fileType?.length > 0 &&
                    <div className='w3-center lgm-600p mx-auto'>
                        {(_message.fileType == 'IMAGE' || GetFileType(_message.file) == 'IMAGE') && <span onClick={() => openInBrowser(getImage(_message.file))} download={_message.file}><img loading='lazy' src={getImage(_message.file)} className="mw-100 img-thumbnail mb-2" alt="Image" /></span>}
                        {_message.fileType == 'AUDIO' && <audio className='w-100 mb-2' src={getImage(_message.file)} preload="none" controls />}
                        {_message.fileType == 'VIDEO' && <video width="100%" src={getImage(_message.file)} className='w-100' controls="controls" preload="none" />}
                        {_message.fileType == 'DOCUMENT' && <span onClick={() => openInBrowser(getImage(_message.file))} className='btn btn-block w3-block w3-theme2-d4 w3-hover-theme1 mb-2'>Download Document</span>}
                    </div>
                }
                <div style={{ whiteSpace: 'pre-wrap' }}><NewlineText>{message}</NewlineText></div>
                <div className='text-end'>
                    <div className='mt-3 mb-1 w3-medium'>--{_message.createdBy}</div>
                </div>

            </div>
        </div>
    );
};




export const Loading = ({ _fullPage = true }) => {
    const fullPage = _fullPage ? 'loading d-flex flex-wrap align-content-center justify-content-center' : 'pt-4 d-flex flex-wrap align-content-center justify-content-center';
    return (
        <div className={fullPage}>
            <div className='text-center'>
                {/* <div className="spinner-grow w3-text-red  ms-2 me-2"></div>
                <div className="spinner-grow w3-text-indigo  ms-2 me-2"></div>
                <div className="spinner-grow w3-text-amber  ms-2 me-2"></div>
                <div className="spinner-grow w3-text-green  ms-2 me-2"></div>
                <div className="spinner-grow w3-text-orange  ms-2 me-2"></div> */}
                <div className="wrapper">
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="shadow"></div>
                    <div className="shadow"></div>
                    <div className="shadow"></div>
                </div>
                <div className='text-center mt-4 w3-wide'>L.O.A.D.I.N.G</div>
            </div>
        </div>
    );
};




export const AILoading = ({ _fullPage = true, message = '' }) => {
    const [timer, setTimer] = useState(0);
    setTimeout(() => { setTimer(timer + 1); }, 1200);
    const fullPage = _fullPage ? 'loading d-flex flex-wrap align-content-center justify-content-center' : 'pt-4 d-flex flex-wrap align-content-center justify-content-center';
    return (
        <div className={fullPage}>
            <div className='text-center'>
                <div className="spinner-grow w3-text-red ms-2 me-2"></div>
                <div className="spinner-grow w3-text-indigo ms-2 me-2"></div>
                <div className="spinner-grow w3-text-amber ms-2 me-2"></div>
                <div className="spinner-grow w3-text-green ms-2 me-2"></div>
                <div className="spinner-grow w3-text-orange ms-2 me-2"></div>

                <div className='text-center mt-4'>Running A.I Model</div>
                <div className='text-center text-muted w3-small'>{message}</div>

                <div className='text-center w3-small my-2'><CheckInIcon /> {Math.floor(timer / 60) + '  mins '} {(timer % 60) + ' secs'} <CheckOutIcon /></div>
            </div>
        </div>
    );
};


export const Refetcher = ({ _method, _loading = false }) => {
    return;
};

export const SwitchRole = () => {
    const brand = getBrand();
    const url = new URL('https://mysyllabux.com/brand.php');
    url.search = new URLSearchParams(brand);
    return <a href={url.toString()} style={{ position: 'fixed', top: 0, left: 0 }} className="w3-text-red w3-hover-text-black w3-xlarge p-1 m-0 me-2" ><i className='bi bi-arrow-up-left-circle-fill'></i></a>;
};
export const HomePageURL = () => {
    const brand = getBrand();
    if (brand?.schoolName?.length < 6) return 'https://mysyllabux.com/brand.php';
    const url = new URL('https://mysyllabux.com/brand.php');
    url.search = new URLSearchParams(brand);
    return url.toString();
};